import React from 'react';

export default function GradeKeyTable({ boundaries = [] }) {
  if (!boundaries.length) return null;
  const sorted = [...boundaries]
    .filter((b, i, arr) => arr.findIndex((x) => x.grade === b.grade) === i)
    .sort((a, b) => b.min_percentage - a.min_percentage);
  return (
    <>
      <p className="rc-section-title">Grading Scale</p>
      <table className="rc-table" style={{ fontSize: '7.5pt' }}>
        <tbody>
          <tr>
            <th style={{ textAlign: 'left', padding: '1px 3px' }}>Grade</th>
            {sorted.map((b) => (
              <td key={b.id ?? b.grade} style={{ textAlign: 'center', fontWeight: 'bold', padding: '1px 3px' }}>{b.grade}</td>
            ))}
          </tr>
          <tr>
            <th style={{ textAlign: 'left', padding: '1px 3px' }}>Range (%)</th>
            {sorted.map((b) => (
              <td key={b.id ?? b.grade} style={{ textAlign: 'center', padding: '1px 3px' }}>{Number(b.min_percentage).toFixed(0)}–{Number(b.max_percentage).toFixed(0)}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </>
  );
}
